module.exports = __webpack_public_path__ + "img/down-arrow.08c9f969.png";